import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    loading: false,
    sidebarOpen: true,
  }),
  actions: {
    toggleLoading(value: boolean) {
      this.loading = value
    },
    toggleSidebar(value: boolean) {
      this.sidebarOpen = value
    },
  },
})
